import { useCallback, useMemo, useState } from "react";
import {
  ColumnChoice,
  getDefaultVisibleColumns,
} from "../components/datagrid/ColumnToggleButton";

export function useColumnVisibility(columns: ColumnChoice[]) {
  const disabledKeys = useMemo(
    () => new Set(columns.filter((c) => c.disabled).map((c) => c.key)),
    [columns],
  );

  const [visibleColumns, setVisibleColumns] = useState<string[]>(() =>
    getDefaultVisibleColumns(columns),
  );

  const toggleColumn = useCallback(
    (key: string) => {
      if (disabledKeys.has(key)) return;
      setVisibleColumns((prev) =>
        prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
      );
    },
    [disabledKeys],
  );

  const resetColumns = useCallback(() => {
    setVisibleColumns(getDefaultVisibleColumns(columns));
  }, [columns]);

  return { visibleColumns, toggleColumn, resetColumns };
}
